/* eslint-disable react/display-name */
import React, { forwardRef, useId } from 'react'
import FormInputField from '../elements/FormInputField'
import Label from '../elements/formLabel'
import { TextSizeType } from '../_config/types'

interface InputProps {
    value?: string
    name?: string
    onChange?: (s: any) => void
    placeholder?: string
    disabled?: boolean
    multiline?: boolean
    className?: string
    error?: string | string[]
    warning?: string
    label?: string
    labelTextSize?: TextSizeType
    isbold?: boolean
    required?: boolean
    validation?: any
    information?: string
    additionalLink?: any
    onBlur?: (e: any) => void
    highlight?: boolean
    title?: string
    showValueInTooltip?: boolean
}

const CommonInputText = forwardRef((props: InputProps, ref: React.Ref<HTMLInputElement | HTMLTextAreaElement>) => {
    const generatedId = useId()
    const inputId = props.name ?? `input-${generatedId}`
    return (
        <div className="w-full">
            {props.label && <Label htmlFor={inputId} text={props.label} {...props} />}
            <FormInputField id={inputId} ref={ref} {...props} />
        </div>
    )
})

export default CommonInputText
